import 'normalize.css';
import render from './render';
import * as app from '@/app';
const { bootstrap } = app || {};
export default typeof bootstrap === 'function' ? bootstrap(render) : render();

// generated at 2025/8/22 09:24:41 by sui v3.1.124